import {
	Col,
	Form,
	Input,
	Modal,
	Row,
	Flex,
	Typography,
	Button,
	Image,
} from "antd";
import React, { useEffect, useState } from "react";

const { Title, Text } = Typography;

const PreviousWorkType = ({ job }) => {
	const [form] = Form.useForm();
	const [openSignatureModal, setOpenSignatureModal] = useState(false);
	const [openLayoutModal, setOpenLayoutModal] = useState(false);
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		if (job) {
			setInitialValues({
				previousWorkLayoutUrl: job.previousWorkLayoutUrl,
				previousWorkSignatureUrl: job.previousWorkSignatureUrl,
				previousWorkTrucksPerHour: job.previousWorkTrucksPerHour || 0,
				previousWorkLaboratory: job.previousWorkLaboratory,
				previousWorkComments: job.previousWorkComments,
				previousWorkContacts: job.previousWorkContacts,
			});
		}
	}, [job]);

	const handleLayoutModal = () => {
		setOpenLayoutModal((prev) => !prev);
	};

	const RenderLayoutModal = () => {
		return (
			<Modal
				title={`Layout draw in previous work ${job.number}`}
				open={openLayoutModal}
				onCancel={handleLayoutModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={job.previousWorkLayoutUrl} />
			</Modal>
		);
	};
	const handleSignatureModal = () => {
		setOpenSignatureModal((prev) => !prev);
	};

	const RenderSignatureModal = () => {
		return (
			<Modal
				title={`Signature draw in previous work ${job.number}`}
				open={openSignatureModal}
				onCancel={handleSignatureModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={job.previousWorkSignatureUrl} />
			</Modal>
		);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item label="Layout Image" name="previousWorkLayoutUrl">
							{job.previousWorkLayoutUrl ? (
								<Button type="primary" size="large" onClick={handleLayoutModal}>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Signature Image" name="previousWorkSignatureUrl">
							{job.previousWorkSignatureUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleSignatureModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Trucks per hour" name="previousWorkTrucksPerHour">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Laboratory" name="previousWorkLaboratory">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Contacts" name="previousWorkContacts">
							<Flex vertical gap={4}>
								{job.previousWorkContacts &&
								job.previousWorkContacts.length > 0 ? (
									job.previousWorkContacts.map((contact, index) => {
										return (
											<Input
												size="large"
												readOnly
												key={index}
												value={contact}
											/>
										);
									})
								) : (
									<Text>No contacts added</Text>
								)}
							</Flex>
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Comments" name="previousWorkComments">
							<Input.TextArea size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Flex vertical>
			<Title level={1}>Previous Work</Title>
			<CustomForm />
			<RenderLayoutModal />
			<RenderSignatureModal />
		</Flex>
	);
};

export default PreviousWorkType;
